module.exports = __webpack_public_path__ + "img/张健.7aac00b6.jpg";